import type { FilterItem } from '@/js/types/filter.ts';
import type { RequestFilter, SelectedFilters, UnifiedFilter } from './types.ts';

export function toSelectedFilters(filterItems: RequestFilter[]): SelectedFilters {
  return filterItems.reduce((acc, item) => {
    if (item.field === 'attributes') {
      item.value.forEach((attr) => {
        acc[attr.attribute_id] = attr.value;
      });
      return acc;
    }
    acc[item.field] = item.value;
    return acc;
  }, {} as SelectedFilters);
}

export function toRequestFilter(selectedFilters: SelectedFilters): RequestFilter[] {
  const filters: RequestFilter[] = [];
  const attributes = Object.entries(selectedFilters)
    .filter(([key, value]) => Number.isInteger(+key) && value !== null && (!Array.isArray(value) || value.length > 0))
    .map(([attribute_id, value]) => {
      return {
        attribute_id,
        value,
      };
    });

  if (attributes.length > 0) {
    filters.push({
      field: 'attributes',
      value: attributes,
    });
  }

  ['manufacturers', 'in_stock'].forEach((field) => {
    if (field in selectedFilters && selectedFilters[field] && Array.isArray(selectedFilters[field]) && selectedFilters[field].length > 0) {
      filters.push({
        field,
        value: selectedFilters[field],
      });
    }
  });
  ['price'].forEach((field) => {
    if (field in selectedFilters && selectedFilters[field]) {
      filters.push({
        field,
        value: selectedFilters[field],
      });
    }
  });

  return filters;
}

export function toUnifiedFilter(filter: FilterItem): UnifiedFilter {
  if (filter.type === 'range' || filter.type === 'price') {
    return {
      name: filter.name,
      type: 'range',
      key: filter.id ?? filter.type,
      min: filter.from,
      max: filter.to,
      open: filter.type === 'price',
    };
  }

  return {
    name: filter.name,
    type: 'variants',
    key: filter.id ?? filter.type,
    items: filter.items.map(item => ({
      id: item.id ?? item.value,
      value: item.value,
      count: item.count,
    })),
    open: filter.type === 'in_stock',
  };
}
